export const locales = {
    ru: {
        deleteAccount: 'Удалить профиль',
    },
    en: {
        deleteAccount: 'Delete Account',
    },
};
